module.exports = __webpack_public_path__ + "1792771649312/fonts/Rubik-Medium.f3e8e53.ttf";